// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".visit-error-notifications > * + *[data-v-1e23b0b6] {\n  margin-top: 0.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
